import React from 'react'

function CallToActionTwo() {
    return (
        <div>
            <>
                {/* rts cta area start */}
                <div className="rts-cta-area ptb--100 rts-cta-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="cta-three-wrapper">
                                    <h4 className="title">
                                        Need Any Business Consultancy? <a href="#">Contact With Us</a>
                                    </h4>
                                    <a className="rts-btn btn-secondary-3" href="contactus.html">
                                        Lets Work Together
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default CallToActionTwo